import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import Shell, { AllySection } from "../../components/allies/Shell";
import Info from "../../components/allies/Me/Info";
import Reservations from "../../components/allies/Me/Reservations";
import Settlements from "../../components/allies/Me/Settlements";
import { useAlly } from "../../context/ally";
import AllyService from "../../services/ally.service";
// Mismo flujo de "agregar tour" que en el inicio del aliado, abierto desde "Mis reservas".
import AddReservationGroup from "../../components/allies/modals/AddReservationGroup";
import TicketPaymentGroup from "../../components/allies/modals/TicketPaymentGroup";
import ConfirmBoucher from "../../components/allies/modals/ConfirmBoucher";
import Summary from "../../components/allies/modals/Summary";

const TABS: AllySection[] = ['reservations', 'settlements']

export default function AllyMe() {
    const {setAllyInfo,
        user,
        newGroup,
        isTicketPaymentGroupModalOpen,
        isConfirmBoucherModalOpen,
        isSummaryModalOpen,
    } = useAlly()
    const router = useNavigate()
    // La pestaña va en la URL (?tab=reservations): "Confirmar" del voucher recarga la página, y así
    // el aliado vuelve a quedar en "Mis reservas" en vez de en el perfil.
    const [searchParams] = useSearchParams()
    const tab: AllySection = TABS.find(t => t === searchParams.get('tab')) || 'profile'

    useEffect(() => {
        if (!user) return router('/ally/access')
    }, [user, router])

    useEffect(() => {
        async function me() {
            try {
                const response = await (await AllyService.me()).data
                setAllyInfo(response)
            } catch (error) {
                console.log(error)
            }
        }
        me()
    }, [])

    return (
        <Shell active={tab}>
            {tab === 'profile' && <Info/>}
            {tab === 'reservations' && <Reservations/>}
            {tab === 'settlements' && <Settlements/>}
            {
                newGroup.length > 0 &&
                <AddReservationGroup/>
            }
            {
                isTicketPaymentGroupModalOpen &&
                <TicketPaymentGroup/>
            }
            {
                isConfirmBoucherModalOpen &&
                <ConfirmBoucher/>
            }
            {
                isSummaryModalOpen &&
                <Summary/>
            }
        </Shell>
    )
}
